import React from "react";
import {
  Flex,
} from "@chakra-ui/react";
import CreatePost from "./components/CreatePost"
const Data = () => {
  return (
    <Flex direction="column" pt={{ base: "62px", md: "75px", xl: "88px" }}>
      <CreatePost />
    </Flex>
  );
}

export default Data;
